document.addEventListener('DOMContentLoaded', ()=>{
  let SwiperTop = new Swiper('.HH-FtbrandiconOUTr.swiper', { spaceBetween: 0, centeredSlides: true, speed: 6000, autoplay: { delay: 1, }, loop: true, slidesPerView:'auto', });
  let overviewSlider = new Swiper('.ExpertsOverviewPointsHg.showOnlyMobile.swiper', { slidesPerView: 1.2, pagination: { el: ".swiper-pagination", clickable: true, }, loop: true });
  let trackSwiper = new Swiper(".ContainerWrapper__Icontext.swiper", { slidesPerView: 4, loop: true, breakpoints: { 1600: { slidesPerView: 4, },1024: { slidesPerView: 3, }, 749: { slidesPerView: 2, }, 0:{ slidesPerView: 1 } }, pagination: { el: ".swiper-pagination", clickable: true, }});
  let productSlider = new Swiper('.BodyLAyoutProductMn.swiper', { slidesPerView: 1.2, spaceBetween: 10, loop: true });
  var bodySwiper = new Swiper(".BodyCOmpositionKeyPontMain.swiper", { slidesPerView: 1, loop: true, breakpoints: { 640: { slidesPerView: 1 }, 749: { slidesPerView: 4,spaceBetween: 15} }, pagination: { el: ".swiper-pagination", clickable: true, }, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", }});
  var popupContentWrapper = document.querySelectorAll(".hsa-fsa-popup-content-wrapper"); if(popupContentWrapper.length){ popupContentWrapper.forEach(function(popup){ popup.addEventListener("click", function() { document.body.classList.add("hsa-popup-open"); document.querySelector(".hsapopupContainer").classList.add("active-open"); }); }) }
  var closeButtn = document.querySelector('.hsapopupContainer .hsaCrsBtn'); if(closeButtn){ closeButtn.addEventListener('click', function() { document.body.classList.remove('hsa-popup-open'); document.querySelector('.hsapopupContainer').classList.remove('active-open'); }); }
  var videoPoup = document.querySelectorAll('[js-popup-view]'); if (videoPoup) { videoPoup.forEach(function(element) { element.addEventListener('click', function(event) { event.preventDefault(); var videoGet = this.getAttribute('video'); var dataAppendElement = document.querySelector('[js-data-append]'); dataAppendElement.innerHTML = videoGet; var popInitializepdpMainElement = document.querySelector('.popINtializepdpMain'); popInitializepdpMainElement.classList.add('active'); document.body.classList.add('MaskedOverlay'); }); }); }
  var videoCross = document.querySelectorAll('[js-cross-popup]'); if (videoCross){ videoCross.forEach(function(element) { element.addEventListener('click', function(e) { e.preventDefault(); document.querySelector('[js-data-append]').innerHTML = ' '; document.querySelector('.popINtializepdpMain').classList.remove('active'); document.body.classList.remove('MaskedOverlay', 'mnPopupWithVertical'); }); });}
  var videoPoupab = document.querySelectorAll('[js-popup-view-ab]'); if (videoPoupab) { videoPoupab.forEach(function(element) { element.addEventListener('click', function(event) { event.preventDefault(); var videoGet = this.getAttribute('video'); var dataAppendElement = document.querySelector('[js-data-append-ab]'); dataAppendElement.innerHTML = videoGet; var popInitializepdpMainElement = document.querySelector('.abtestPopupActivate'); popInitializepdpMainElement.classList.add('active'); document.body.classList.add('MaskedOverlay'); }); }); }
  var videoCrossab = document.querySelectorAll('[js-cross-popup-ab]'); if (videoCrossab){ videoCrossab.forEach(function(element) { element.addEventListener('click', function(e) { e.preventDefault(); document.querySelector('[js-data-append-ab]').innerHTML = ' '; document.querySelector('.abtestPopupActivate').classList.remove('active'); document.body.classList.remove('MaskedOverlay', 'mnPopupWithVertical'); }); });}
  var MetricsSlider = new Swiper(".BodyMetricsSliderMbVw.swiper", { slidesPerView: 2, loop: false, pagination: { el: ".swiper-pagination", clickable: true, },navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev", }});
  let productSliderab = new Swiper('.BodyLAyoutProductMnabinit.swiper', { slidesPerView: 1.2, spaceBetween: 10 });
  let announcemnet$barsticky = new Swiper('.WpSwiperLayoutBarStk.swiper', { slidesPerView:1,loop:true,autoplay:{delay:3000},observer: true, }); 
  
  if( document.querySelectorAll(`.bqty-header`).length == 0 ){
  let ScrollTargetPDP = document.querySelectorAll(".ScrollerPdpAtc, .Dsrgyu, .Humeband-block-button, [js-scroll-to-destination]");
  ScrollTargetPDP.forEach((evt)=>{
    evt.addEventListener('click', (target)=>{
      target.preventDefault();
      if(!evt.classList.contains("ScrollerPdpAtcbtn_body-pod-science") && !evt.classList.contains("ScrollerPdpAtcbtn_hume-band")){
         
        if(window.innerWidth > 769){
          var targetElement = document.querySelector('.MainProductRightPortionWp');
          window.scrollTo({
            // top: targetElement.offsetTop - document.querySelector('#shopify-section-announcement-bar').clientHeight,
            behavior: 'smooth'
          });
        }else{
          var targetElement = document.querySelector('.WarrantyProtectionWp');
          window.scrollTo({
            top: targetElement.offsetTop - 120,
            behavior: 'smooth'
          });
        }  
      }
 
    })
  });
  }


  function isInViewportStickyElement(elem) { 
    var bounding = elem.getBoundingClientRect();
    var myElementHeight = elem.offsetHeight;
    var myElementWidth = elem.offsetWidth;
    return (bounding.top >= -myElementHeight && bounding.left >= -myElementWidth && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) ; 
  };
  
  var recommendationElementTest = document.querySelectorAll('.mapwithouttest');
  window.addEventListener('scroll', ()=>{
    recommendationElementTest.forEach( (evt)=>{
      if ( isInViewportStickyElement(evt) ) {
        document.querySelectorAll(".withoutabteststk").forEach((target)=>{
          target.classList.add('hidden');
        });
      }else{
        document.querySelectorAll(".withoutabteststk").forEach((target)=>{
          target.classList.remove('hidden');
        });
      }
    })
  })
  
  var quantity = document.querySelector('.quantity-control-button.add'); if(quantity){ quantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; inputElement.value = inputValue + 1; }) }
  var minusQuantity = document.querySelector('.quantity-control-button.subtract'); if(minusQuantity){ minusQuantity.addEventListener('click', function(e){ e.preventDefault(); var inputElement  = this.closest('.number-input-control').querySelector('.input-text'); var inputValue = parseInt(inputElement.value) || 0; if (inputValue > 1) { inputElement.value = inputValue - 1; }})}
  
  document.addEventListener('click', function(event) {
    var targetElement = event.target.closest('.Wphyopyiomshy');
    if (targetElement) { 
      event.preventDefault();
      targetElement.classList.add('active');
      var siblings = targetElement.parentNode.querySelectorAll('.Wphyopyiomshy');
      siblings.forEach(function(sibling) {
        if (sibling !== targetElement) {
          sibling.classList.remove('active'); 
        } 
      });

      if( document.querySelectorAll('.ab_test_addbtn.OneClick_Popup').length > 0 ){
        let productPrice = targetElement.getAttribute('normal_price');
        let productCPrice = targetElement.getAttribute('normal_compare_price');
        let splitPrice = targetElement.getAttribute('splitprice');
        document.querySelector('.ab_test_addbtn.OneClick_Popup').children[0].innerHTML = `<span class="innrAb_det">ADD TO CART <ht></ht> <del>${productCPrice}</del><span class="abpricejune1">${productPrice}</span></span>`;
        document.querySelectorAll('.KlarnaLmsg').forEach((elm)=>{elm.innerHTML = `or 18 payments of ${splitPrice} with`});
      }
      
    } 
  });

  
  var oncliickpopup= document.querySelector('.Wphyopyiomshy'); if(oncliickpopup){ oncliickpopup.addEventListener('click', function (evt) { evt.preventDefault(); document.querySelector('.OneClick_Popup').classList.add('show-checked') })}

  if(!document.body.classList.contains('custom_cart_drawer_ongoing')){
    if( document.querySelectorAll('.ab_test_addbtn.OneClick_Popup').length > 0 ){
      document.querySelector('.ab_test_addbtn.OneClick_Popup').addEventListener('click', function(evt){
        evt.preventDefault();
        if (!document.querySelector('.main-button-actionYet.OneClick_Popup').classList.contains('show-checked')) {
          let thisElm = this;
          thisElm.classList.add('clickedMe');
          var mainID = this.getAttribute('main-productid'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
          formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
          .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
          .then(data => {
            thisElm.classList.remove('clickedMe');
            if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
            else { window.location.href = '/checkout'; }
          }) 
        }else if(document.querySelector('.main-button-actionYet.OneClick_Popup').classList.contains('WarrantyDisabledPopup')){
          let thisElm = this;
          thisElm.classList.add('clickedMe');
          var mainID = this.getAttribute('data-without-popup'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
          formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
          .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
          .then(data => {
            thisElm.classList.remove('clickedMe');
            if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
            else { window.location.href = '/checkout'; } 
          })      
        }else{
          document.querySelector('.Product_Popup').classList.add('popup-open'); document.body.classList.add('popup-show');
        }
      })    
    }
  }
  
  var onlyClick= document.querySelector('.OnlyAvailThat'); if(onlyClick){ onlyClick.addEventListener('click', function (evt) { evt.preventDefault(); document.querySelector('.OneClick_Popup').classList.remove('show-checked') })}

  if(!document.body.classList.contains('custom_cart_drawer_ongoing')){
  document?.querySelector('.OneClick_Popup')?.addEventListener('click', function(evt){
    evt.preventDefault();
    if (!this.classList.contains('show-checked')) {
      let thisElm = this;
      thisElm.classList.add('clickedMe');
      var mainID = this.getAttribute('main-productid'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
      formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
      .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
      .then(data => {
        thisElm.classList.remove('clickedMe');
        if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
        else { window.location.href = '/checkout'; } 
      }) 
    }else if(this.classList.contains('WarrantyDisabledPopup')){
      let thisElm = this;
      thisElm.classList.add('clickedMe');
      var mainID = this.getAttribute('data-without-popup'); var mnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); 
      formData.append('quantity', mnpQy); formData.append('id', mainID); fetch('/cart/add.js', { method: 'POST', body: formData }) 
      .then(response => { if (!response.ok) { throw new Error('Network response was not ok'); } return response.json(); }) 
      .then(data => {
        thisElm.classList.remove('clickedMe');
        if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
        else { window.location.href = '/checkout'; }
      })      
    }else{
      document.querySelector('.Product_Popup').classList.add('popup-open'); document.body.classList.add('popup-show');
    }
  })
}

  if ( document.querySelectorAll('.Promotion_widget_popup_contentw').length > 0 ){
    document.querySelectorAll('.Promotion_widget_popup_contentw').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.body.classList.add('promotion_view');
      })
    })
    document.querySelectorAll('.giveaway_close_widget').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.body.classList.remove('promotion_view');
      })
    }) 
    document.querySelectorAll('.popup_overlayMn').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        document.body.classList.remove('promotion_view');
      })
    })     
  }
  
  document?.querySelector('.PopupCloseBtn')?.addEventListener('click', function(evt){ evt.preventDefault(); document.querySelector('.Product_Popup').classList.remove('popup-open'); document.body.classList.remove('popup-show'); var MNPDID = this.getAttribute('MainProduct'); var MnpQy = document.querySelector('[title="Qty"]').value; var formData = new FormData(); formData.append('quantity', MnpQy); formData.append('id', MNPDID); fetch('/cart/add.js', { method: 'POST', body: formData }) .then(response => { if (response.ok) {return response.json();  } else { throw new Error('Network response was not ok'); } }) .then(data => { window.location.href = '/checkout'; }) .catch(error => {  console.error('Error adding to cart:', error);}); });

  document.querySelectorAll('.MainStarReviewsPdp, .RatingWithElmOpyi').forEach((event)=>{
    event.addEventListener('click', (evt)=>{
      evt.preventDefault();
        var targetElement = document.querySelector('.WidgetreviewsLoader');
        if ( window.screen.width > 769) {
          window.scrollTo({
            top: targetElement.offsetTop - 158,
            behavior: 'smooth'
          });    
        }else{
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });           
        }
    })
  });

  document.querySelectorAll('.Tilemnexh').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      target.target.closest('.CollpsmnTabex').classList.toggle('active');
    });
  });

  document.querySelectorAll('.accordianjshandle').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      target.target.closest('.custom-faqs-Items').classList.toggle('active');
    });
  });  

  document.querySelectorAll('.wpunijtysh').forEach((elm)=>{
    elm.addEventListener('click', (target)=>{
      target.preventDefault();
      if( target.currentTarget.classList.contains('TargetToDivElement') ){
        var targetElement = document.querySelector('.WidgetreviewsLoader');
        if ( window.screen.width > 769) {
          window.scrollTo({
            top: targetElement.offsetTop - 158,
            behavior: 'smooth'
          });    
        }else{
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });           
        }        
      }else{
        target.target.closest('.Tabinityiniopsmkm').classList.toggle('active');
      }
    });
  });  
  
  const videoWrapper = document.querySelector('.TextRow__VideoWrapper, .WillNotShowOnBodyPodPDMN, .bandProspecting__mainwrapper');
  const scrollingBar = document.querySelector('.ListScrollingBarWp');
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');

  function handleScroll() {
    const scrollPosition = window.scrollY;
    if (videoWrapper) {
      const showBuyBarPosition = videoWrapper.offsetTop;
      if (scrollPosition > showBuyBarPosition) {
        scrollingBar.classList.add('active');
        document.body.classList.add('HiddenHeaderBar');
      } else {
        // scrollingBar.classList.remove('active');
        document.body.classList.remove('HiddenHeaderBar');
      }
    }
    const announcementBarHeight = announcementBar.offsetHeight;
    scrollingBar.style.top = `${announcementBarHeight}px`;
  }
  if(scrollingBar){
    window.addEventListener('scroll', handleScroll);
  }
  
  var scrollNav = document.querySelectorAll('[desktop-data-title]');
  if (scrollNav.length > 0) {
    scrollNav.forEach(function (scroll) {
      scroll.addEventListener('click', function (evt) {
        scrollNav.forEach(function (el) {
          el.classList.remove('active');
        });
        evt.currentTarget.classList.add('active');
        var scrollTargets = {
          Reviews: '.WidgetreviewsLoader',
          FAQ: '#new-accordians',
          Specs: '[section="cdv-electrodermal-activity"]',
          Overview: '[section="FT-body-pod-product"]'
        };
        var targetElement = document.querySelector(scrollTargets[evt.currentTarget.getAttribute('desktop-data-title')]);
        if(window.innerWidth < 750){
          window.scrollTo({
            top: targetElement.offsetTop - 50,
            behavior: 'smooth'
          });
        }else{
          window.scrollTo({
            top: targetElement.offsetTop - 158,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  if(window.innerWidth > 750){
    var imageZoomModal = document.querySelectorAll('.mgMediaopt');
    if(imageZoomModal){
      imageZoomModal.forEach(function(modal){
        modal.addEventListener('click', function (evt) {
          evt.preventDefault();
          var mediaId = this.getAttribute('mediamain');
          var imageUrl = document.querySelector(`[mediamain="${mediaId}"]`).getAttribute('imagesrc');
          var imgMNTG = `<img src="${imageUrl}" preload="true" loading="eager">`;
          document.querySelector('.appendImageMN').innerHTML = imgMNTG;
          document.querySelector('.ImageZoomModal').classList.add('active');
          document.body.classList.add('popActive');
        });
      });
    }
    var imageZoom = document.querySelectorAll('.thumbNailed');
    if(imageZoom){
      imageZoom.forEach(function(zoom){
        zoom.addEventListener('click', function (event) {
          event.preventDefault();
          var mediaId = this.getAttribute('mediathumb');
          var imageUrl = document.querySelector(`[mediathumb="${mediaId}"]`).getAttribute('imagesrc');
          var imgMNTG = `<img src="${imageUrl}" preload="true" loading="eager">`;
          document.querySelector('.appendImageMN').innerHTML = imgMNTG;
          document.querySelector('.ImageZoomModal').classList.add('active'); document.body.classList.add('popActive');
        });
      });
    }
    var crossZoom = document.querySelector('.CrossZoomImgModal');
    if(crossZoom){
      crossZoom.addEventListener('click', function (evt) {
        evt.preventDefault();
        document.querySelector('.appendImageMN').innerHTML = '';
        document.querySelector('.ImageZoomModal').classList.remove('active'); document.body.classList.remove('popActive');
      })
    }    
  }
 
  document.querySelectorAll('.customPopupATC').forEach((event)=>{
      event.addEventListener('click', function(evt){ 
      evt.preventDefault(); 
      let thisloader = this;
      thisloader.children[1].classList.remove('hidden');
      var MNPDID = this.getAttribute('MainProduct'); var MnpQy = document.querySelector('[title="Qty"]').value; 
      var formData = new FormData(); formData.append('quantity', MnpQy); formData.append('id', MNPDID);
      fetch('/cart/add.js', { method: 'POST', body: formData }) 
        .then(response => { return response.json(); }) 
        .then(data => { 
          thisloader.children[1].classList.add('hidden');       
          if (window.HumeCart && window.HumeCart.active) { window.HumeCart.open(); }
          else { window.location.href = '/checkout'; } 
        });
    });
  });

  var pdfPopup = document.querySelectorAll('[js-pdf-view]');
  if(pdfPopup){
    pdfPopup.forEach(function(evt){
      evt.addEventListener('click',function(e){
        e.preventDefault();
        let Pdf_Document;
        if( window.screen.width < 750 ){
        Pdf_Document = `<div class="ReporpdfPopup"> 
                            <object style="width: 100%; height: 100vh;" data="https://cdn.shopify.com/s/files/1/0557/7188/9712/files/accuracy_report.pdf#toolbar=0">
                              <iframe style="width: 100%; height: 100%;" src="https://cdn.shopify.com/s/files/1/0557/7188/9712/files/accuracy_report.pdf#toolbar=0"></iframe>
                            </object>
                        </div>`          
        }else{
        Pdf_Document = `<div class="ReporpdfPopup"> 
                          <iframe style="width: 100%; height: 100%;" src="https://cdn.shopify.com/s/files/1/0557/7188/9712/files/accuracy_report.pdf#toolbar=0"></iframe>
                        </div>`  
        }
        document.querySelector('[Pdfreport]').classList.add('activepdf');
        document.body.classList.add('open-pdf');
        document.querySelector('[Pdfreport]').querySelector('.ContentPDFPopupWpInt').innerHTML = Pdf_Document;
      });
    }) 
  }
  
  var pdfCross = document.querySelectorAll('[js-cross-Pdf]');
  if(pdfCross){
    pdfCross.forEach(function(evt){
      evt.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('[Pdfreport]').classList.remove('activepdf');
        document.body.classList.remove('open-pdf');
        document.querySelector('[Pdfreport]').querySelector('.ContentPDFPopupWpInt').innerHTML = '';
      });
    });
  }
  
  var outSideclick = document.querySelectorAll('.ReportPDFOverlay');
  if(outSideclick){
    outSideclick.forEach(function(evt){
      evt.addEventListener('click',function(e){
        document.querySelector('[Pdfreport]').classList.remove('activepdf');
        document.body.classList.remove('open-pdf');
        document.querySelector('[Pdfreport]').querySelector('.ContentPDFPopupWpInt').innerHTML = '';
      });
    });
  }
});

(function fixBuyBoxGoalTypo() {
  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.nodeValue = node.nodeValue.replace('tour goals', 'your goals');
      return;
    }

    node.childNodes.forEach(replaceText);
  }

  function run() {
    document.querySelectorAll('.callout-description').forEach(replaceText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setTimeout(run, 500);
  setTimeout(run, 1500);
})();
